"use strict";
// TODO: vsavkin rename it into TemplateLoader
/**
 * An interface for retrieving documents by URL that the compiler uses
 * to load templates.
 */
var XHR = (function () {
    function XHR() {
    }
    XHR.prototype.get = function (url) { return null; };
    return XHR;
}());
exports.XHR = XHR;
//# sourceMappingURL=xhr.js.map


/*****************
 ** WEBPACK FOOTER
 ** /var/www/smartwifi/shared/~/@angular/compiler/src/xhr.js
 ** module id = 178
 ** module chunks = 0 1 2
 **/